<input #fileInput type="file" (change)="change($event)" [accept]="allowedFileExtensions ?? '*'" multiple style="display: none" />

<label>{{ "file.label.title" | translate }}</label>
<div class="file__list" *ngFor="let file of uploadedFiles">
  <div>
    <div>
      <span class="icon icon-category-abonnementen"></span>
      <p class="file__list--label">{{ file.name }}</p>
    </div>
    <a class="button button--transparent" (click)="remove(file)"><i class="icon icon-ui-close"></i></a>
  </div>
  <progress id="file" [value]="file.progress" [hidden]="file.progress === 100" max="100" class="progress file__list--progress"></progress>
</div>

<div class="file__drag-and-drop" airDragAndDrop (filesDropped)="upload($event)" (click)="open($event)">
  <button type="button" class="button">
    <i class="icon icon-ui-plus d--none--sm"></i>
    <ng-container *ngIf="!uploadedFiles?.length">{{ "file.label.select" | translate }}</ng-container>
    <ng-container *ngIf="uploadedFiles?.length">{{ "file.label.select_another" | translate }}</ng-container>
  </button>
  <p *ngIf="!isMobile">{{ "file.label.drag_and_drop" | translate }}</p>
</div>
<p class="text--sm">
  {{ maxUploadSizeMBMessage }}
  <ng-container *ngIf="allowedFileExtensions">{{ allowedFileExtensionsMessage }}</ng-container>
</p>
